import { render, staticRenderFns } from "./tableOrderFulfillment.template.vue?vue&type=template&id=338fcc8e&scoped=true&"
var script = {}
import style0 from "./tableOrderFulfillment.template.vue?vue&type=style&index=0&id=338fcc8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fcc8e",
  null
  
)

export default component.exports